import axios from 'axios';

export async function queryEvents(params = {}) {
  try {
    const baseURL = process.env.REACT_APP_BACKEND_URL;
    const eventIngestKey = process.env.REACT_APP_EVENT_INGEST_KEY;
    
    // Build query parameters
    const queryParams = new URLSearchParams();
    
    if (params.user_id) {
      queryParams.append('user_id', params.user_id);
    }
    if (params.event_name) {
      queryParams.append('event_name', params.event_name);
    }
    if (params.platform) {
      queryParams.append('platform', params.platform);
    }
    if (params.fromTime) {
      queryParams.append('fromTime', params.fromTime);
    }
    if (params.toTime) {
      queryParams.append('toTime', params.toTime);
    }
    
    const url = `${baseURL}/events-system${queryParams.toString() ? '?' + queryParams.toString() : ''}`;

    const res = await axios.get(url, {
      headers: {
        'Authorization': eventIngestKey
      }
    });
    
    return res;
  } catch (err) {
    console.error('Error querying events:', err);
    return err;
  }
}

